import React, { FC } from "react";
import { HealthCareListProps } from "../../props/HealthCareProps";
import { Flex, Pagination, PaginationProps, Skeleton } from "antd";
import HealthCareCard from "./HealthCareCard";

const HealthCareList: FC<HealthCareListProps> = ({
  currentPage,
  totalHealthCares,
  allHealthCares,
  isFetchingAllHealthCares,
  healthCareIds,
  handlePageChange,
  handleNavigate,
}) => {
  const onPageChange: PaginationProps["onChange"] = (page) => {
    handlePageChange(page);
  };
  return (
    <>
      {isFetchingAllHealthCares ? (
        <Skeleton active paragraph={{ rows: 10 }} />
      ) : (
        <Flex vertical align="center">
          <div style={{ width: "100%" }}>
            {healthCareIds?.map((healthCareId) => (
              <HealthCareCard
                key={healthCareId}
                id={healthCareId}
                healthCareList={allHealthCares}
                handleNavigate={handleNavigate}
              />
            ))}
          </div>
          <Pagination
            onChange={onPageChange}
            showSizeChanger={false}
            style={{ marginTop: "1em" }}
            current={currentPage}
            total={totalHealthCares}
          />
        </Flex>
      )}
    </>
  );
};

export default HealthCareList;
